"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KycQuestionTypes = exports.KycStatuses = exports.useQuestionManager = void 0;
var hooks_1 = require("../hooks");
Object.defineProperty(exports, "useQuestionManager", { enumerable: true, get: function () { return hooks_1.useQuestionManager; } });
var types_1 = require("../hooks/useQuestionManager/types");
Object.defineProperty(exports, "KycStatuses", { enumerable: true, get: function () { return types_1.KycStatuses; } });
Object.defineProperty(exports, "KycQuestionTypes", { enumerable: true, get: function () { return types_1.KycQuestionTypes; } });
//# sourceMappingURL=index.js.map